module.exports = __webpack_public_path__ + "static/media/logo_active.1107366e.png";